<script lang="ts">
    export let color = "crimson";
    export let backColor = "orange";
</script>

<main style="color: {color}; text-shadow: 2px 2px 20px {backColor}">
    <div class="animate">
        <slot />
    </div>
</main>

<style>
    .animate {
        animation: growth 1s;
        font-size: xx-large;
        font-weight: bold;
    }

    @keyframes growth {
        0% {
            font-size: smaller;
        }

        100% {
            font-size: xx-large;
        }
    }
</style>
